<template>
	<div>
		<page-title :title="translationHeader.title"/>
		<div id="header-div">
			<div class="info-description">
				<p>{{translationHeader.text}}</p>
			</div>
		</div>

		<div id="tabs_div">
			<div class="years">
				<span>{{translation.asideYearsTabText}}</span>
				<ul class="tabs">
					<li v-for="year in years" v-on:click="handleEventsByYear(year)" :key="year">{{year}}</li>
				</ul>
			</div>

			<div id="resume-table">
				<table>
					<tr>
						<th>{{translateHeaderTable.name}} {{currentYear}}</th>
						<th>{{translateHeaderTable.start}}</th>
						<th>{{translateHeaderTable.end}}</th>
						<th>{{translateHeaderTable.local}}</th>
					</tr>
					<tr v-for="event in events" id="td-row" :key="event.id" v-if="event.name">
						<td>{{translateEvent(event).name}}</td>
						<td>{{formatDate(event.startDate)}}</td>
						<td>{{formatDate(event.endDate)}}</td>
						<td>{{event.local? event.local.name: ''}}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import EventService from '../../services/EventService';
import { translate } from '../../assets/translations';
import { formatDate } from '../../assets/format';

export default {
	computed: {
		translation() {
			return translate(this.$store.state.language).home;
		},
		translationHeader() {
			return translate(this.$store.state.language).resumeSubtitle;
		},
		translateHeaderTable() {
			return translate(this.$store.state.language).resumeTableHeaderLabels;
		},
		events() {
			return this.sortByYear(this.currentYear);
		}
	},
	data() {
		return {
			eventService: new EventService(),
			allEvents: [],
			currentYear: '',
			years: [],
		}
	},
	mounted() {
		this.fetchEvents();
	},
	methods: {
		async fetchEvents() {
			let response = await this.eventService.getAllDefinitive();
			this.allEvents = response.data;
			this.setYears(this.allEvents);
			this.handleEventsByYear(Math.max(...this.years));
		},
		setYears(allEvents) {
			let arrayYears = allEvents.map(event => parseInt(event.startDate.split('-')[0]));
			this.years = Array.from(new Set(arrayYears));
		},
		sortByYear(year) {
			const filteredEvents = this.allEvents.filter(event => parseInt(event.startDate.split('-')[0]) === year);
			const compareDates = (a, b) => {
				const dateA = new Date(a.startDate);
				const dateB = new Date(b.startDate);
				return dateA.getTime() - dateB.getTime();
			}
			return filteredEvents.sort(compareDates);
		},
		handleEventsByYear(year) {
			this.currentYear = year;
			this.sortByYear(year);
		},
		translateEvent(event) {
			let current = this.$store.state.language;
			return event.translations.find(l => l.language.id === current.id);
		},
		formatDate(date){
			return formatDate(date, "DD/MM");
		},
	},
}
</script>

<style>
.info-description {
		color: #686868;
		font-size: 13px;
		padding-top: 1px;
		padding-left: 2%;
		padding-right: 2%;
		margin: 0 auto;
		text-align: justify;
}

#header-div {
	max-width: 960px;
	margin-left: auto;
	margin-right: auto;
}
</style>

<style>
#resume-table {
	border-collapse: collapse;
	text-align: center;
	margin: 20px auto 50px auto;
	color: #646464;

	width: 100%;

}

#resume-table table {
	max-width: 900px;
	border-collapse: collapse;
	margin-left: auto;
	margin-right: auto;
	width: 100%;
}

#resume-table th,
td {
	text-align: center;
}

#resume-table th {
	background-color: #e6e4e4;
	font-size: 14px;
	height: 40px;
	text-align: center;
}

#resume-table td {
	width: 25%;
	font-size: 13px;
	border: 1.5px solid #d8d8d8;
	border-collapse: collapse;
	padding: 5px;
}

#resume-table table #td-row:hover{
	background-color: #8eceec;
	color: #f7f7f7;
}

.resume {
	max-width: 960px;
	margin: 20px auto 5px auto;
}

.subtitle {
	font-size: 13px;
	margin: 10px;
	text-align: justify;
	color: #686868;
}

#tabs_div {
	max-width: 960px;
	margin-left: auto;
	margin-right: auto;
}
</style>

<style scoped lang="scss">
.years {
	margin: 10px auto;
	border-bottom: 1px solid #253b6d;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	span {
		color: #5a5a5a;
    font-size: .8em;
	}
	height: 40px;
}

@media (max-width: 500px) {
	.years span, main > p {
		display: none;
	}
}

.tabs {

	min-width: 250px;

	@media (max-width: 900px) {
		min-width: unset;
	}


	li {
		padding: 5px;
		width: max-content;
		margin: 0 5px;
		border-radius: 5px 5px 0 0;
		background: #ececec;
		font-size: 1.2em;
		display: inline-block;
		cursor: pointer;
	}

	li:hover {
		background: #bbb8b8;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/resume/Resume.vue